import React, { useState } from 'react';
import { message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalComponent from '@components/common/Modal';
import DataManagementApi from 'apis/api/DataManagement';

interface IProps {
  isOpen: boolean;
  rowSelect: any;
  callBackClose: () => void;
  callBackRefresh: () => void;
}

export default function DeleteReturnProduct({ isOpen, rowSelect, callBackClose, callBackRefresh }: IProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    if (!rowSelect?.id) {
      message.error('Không xác định được dòng cần xoá');
      return;
    }

    setLoading(true);
    try {
      const res = await DataManagementApi.DeleteReturnProduct(rowSelect.id);

      if (!res?.data?.error) {
        message.success('Xoá dòng trả hàng thành công');
        callBackClose();
        callBackRefresh();
      } else {
        message.error(res?.data?.message || 'Xoá thất bại');
      }
    } catch (error) {
      console.log(error);
      message.error('Xoá thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalComponent
      title="Xác nhận xoá"
      visible={isOpen}
      onCancel={callBackClose}
      onOk={handleDelete}
      confirmLoading={loading}
      okText="Xoá"
      okButtonProps={{ danger: true, type: 'primary' }}
      cancelText="Huỷ"
      maskClosable={false}
      destroyOnClose
    >
      <div className="flex items-start gap-3">
        <ExclamationCircleOutlined rev={''} className="text-red-500 text-xl mt-0.5" />
        <div className="text-sm">
          <p className="m-0">Bạn có chắc chắn muốn xoá dòng trả hàng này không?</p>
          {/* <p className="m-0 mt-1 text-gray-500">
            Phiếu <span className="font-semibold">{rowSelect?.voucherNo}</span> - dòng{' '}
            <span className="font-semibold">{rowSelect?.lineNo}</span> - {rowSelect?.productName}
          </p> */}
          <p className="m-0 mt-2 text-red-500">Hành động này không thể hoàn tác.</p>
        </div>
      </div>
    </ModalComponent>
  );
}
